import React, { useState } from 'react';
import Attention from '../../ReusableComponents/Attention';
import PortalFormModal from './PortalFormModal';

export default function ReviewDecisionModal({
  title,
  description,
  mutation,
  onClose,
  options,
  reasonName = 'reason',
  reasonLabel = 'Justificativa',
  minLength = 5,
  maxLength = 10000,
  submitText = 'Salvar análise',
  children,
  defaultStatus,
  defaultReason = '',
  reasonRequired = true,
  approvalBlocked = false,
}) {
  const [status, setStatus] = useState(defaultStatus || options[0]?.[0] || '');
  return (
    <PortalFormModal
      title={title}
      description={description}
      onClose={onClose}
      busy={mutation.isLoading}
      allowed={mutation.allowed}
      error={mutation.error}
      submitText={submitText}
      submitDisabled={approvalBlocked && status === 'approved'}
      onSubmit={(event) =>
        mutation.mutate(Object.fromEntries(new FormData(event.currentTarget)), {
          onSuccess: onClose,
        })
      }
    >
      <label className="form-label">
        <span>
          Decisão <Attention />
        </span>
        <select
          name="status"
          className="form-control form-select"
          required
          value={status}
          onChange={event => setStatus(event.target.value)}
        >
          {options.map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </label>
      {children}
      <label className="form-label">
        <span>
          {reasonLabel} {reasonRequired ? <Attention /> : <small className="text-muted">(opcional)</small>}
        </span>
        <textarea
          name={reasonName}
          defaultValue={defaultReason}
          className="form-control"
          rows={4}
          minLength={reasonRequired ? minLength : undefined}
          maxLength={maxLength}
          required={reasonRequired}
        />
      </label>
    </PortalFormModal>
  );
}
